export default __webpack_public_path__ + "static/media/IMG_00007.98949c94.jpeg";